import React, { useRef, useState } from 'react';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { ExtendedTableLowCode } from '@/components/shared/table/ExtendedTableLowCode';
import { useCustomSpec } from '@/utils/hooks/useCustomSpec';
import { Button, Dialog, ModalRef } from 'alurkerja-ui';
import { useParams } from 'react-router-dom';
import { ReleaseService } from '@/api/release';
import { IFilterSpec } from '@/components/shared/filter/TableFilterPanel';
import { useBackNavigate } from '@/utils/hooks/useBackNavigate';
import { HideCustomCreateButton } from '@/components/shared/button/HideCustomButtonCreate';

export const ListArchiveRelease: React.FC = () => {
  const { id } = useParams();
  const backNavigate = useBackNavigate();
  const ref = useRef<ModalRef>(null);

  const spec = useCustomSpec('/api/crud/release', {
    columns: [
      { key: 'name', label: 'Title' },
      { key: 'start_date', label: 'Start Date', type: 'date' },
      { key: 'end_date', label: 'End Date', type: 'date' },
    ],
  });

  const filterSpec: IFilterSpec[] = [
    { name: 'name', label: 'Title', type: 'text' },
    { name: 'start_date', label: 'Start Date', type: 'date' },
    { name: 'end_date', label: 'End Date', type: 'date' },
  ];

  const [selectedRow, setSelectedRow] = useState<string[]>([]);
  const { mutate: unArchiveMutate, isPending: isUnarchiveLoading } =
    ReleaseService.useUnarchive();

  const unarchiveAction = (idList: string[]) => {
    idList.forEach(id => {
      unArchiveMutate(id, {
        onSuccess: () => {
          Dialog.success({
            title: 'Success',
            description: 'Release has been Unarchived',
            callback: () => {
              ref.current?.closeModal();
              backNavigate();
            },
          });
        },
        onError: () => {
          Dialog.error({
            title: 'Error',
            description: 'Failed to Unarchive release',
          });
        },
      });
    });
  };

  return (
    <div className="tab-group">
      <div className="justify-between tab-list">
        <OutlineButton onClick={backNavigate}>Back</OutlineButton>

        <Button
          onClick={() => unarchiveAction(selectedRow)}
          loading={isUnarchiveLoading}
          disabled={selectedRow.length === 0}
        >
          Revert Back
        </Button>
      </div>

      <div className="mx-4">
        <ExtendedTableLowCode
          spec={spec}
          defaultFilter={{ project_id: id, is_archive: true }}
          hideActionColumn
          customButtonCreate={HideCustomCreateButton}
          showCheckbox
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          filterSpec={filterSpec}
          showFilter
        />
      </div>
    </div>
  );
};
